import { resetAccount } from "src/states/account"
import { resetAccountForm } from "src/states/accountForm"
import { resetAccountFormWebshop } from "src/states/accountFormWebshop"
import { resetBooking } from "src/states/bookingDetail"
import { resetBookingDetailFiles } from "src/states/bookingDetailFiles"
import { resetBookings } from "src/states/bookings"
import { resetBookingsExternal } from "src/states/bookingsExternal"
import { resetSalesorder } from "src/states/salesorder"
import { resetFilter } from "src/states/shop/filter"

export const resetStates = async () => {
  resetAccount()
  resetAccountForm()
  resetAccountFormWebshop()
  resetBooking()
  resetBookings()
  resetBookingsExternal()
  resetBookingDetailFiles()
  resetSalesorder()
  resetFilter()
}
